// Expand-any-plot-to-fullscreen. A chart calls useFullscreen(), spreads the
// class onto its .chart-panel, and drops <fs.Btn/> in the corner. Toggling adds
// position:fixed full-screen (the viewBox SVG just scales up) — no remount, so
// hover state and data are preserved. Esc or the ✕ closes it.
import { useEffect } from "react";
import { useState } from "react";

// Refcounted body scroll-lock. Every overlay (Modal, StockModal, TradeMode, fullscreen charts,
// Designer) shares the SAME `fs-lock` class on <body>. With a raw add/remove, two simultaneous
// overlays race: closing one calls classList.remove('fs-lock') and unlocks the body behind the
// OTHER (e.g. Today ?trade=X&stock=Y mounts TradeMode AND StockModal). Refcount it: lockScroll()
// adds the class only on the 0→1 transition, unlockScroll() removes it only on 1→0 (floored at 0),
// so the body stays locked until the LAST overlay closes.
let _lockCount = 0;
export function lockScroll() {
  _lockCount += 1;
  if (_lockCount === 1) document.body.classList.add("fs-lock");
}
export function unlockScroll() {
  _lockCount = Math.max(0, _lockCount - 1);
  if (_lockCount === 0) document.body.classList.remove("fs-lock");
}

export function useFullscreen() {
  const [full, setFull] = useState(false);
  useEffect(() => {
    if (!full) return;
    const onKey = (e) => { if (e.key === "Escape") setFull(false); };
    document.addEventListener("keydown", onKey);
    lockScroll();
    return () => { document.removeEventListener("keydown", onKey); unlockScroll(); };
  }, [full]);
  const Btn = () => (
    <button className="fs-btn" onClick={() => setFull((f) => !f)}
      title={full ? "Close (Esc)" : "Expand to full screen"} aria-label="Expand chart">
      {full ? "✕" : "⤢"}
    </button>
  );
  return { full, cls: full ? " chart-panel--full" : "", Btn, close: () => setFull(false) };
}
